import { Search, Menu, Phone } from "lucide-react";

export default function Header() {
  return (
    <header className="bg-[#ccd5ae] py-4 px-3 md:px-6 flex justify-between items-center relative">
      {/* Report A Crime Button with Phone Icon */}
      <button className="bg-red-700 text-white font-semibold px-4 py-2 rounded-full flex items-center space-x-2 hover:bg-red-800 transition transform hover:scale-105 shadow-md text-sm md:text-base">
        <Phone className="w-4 h-4 md:w-5 md:h-5" />
        <span>Report</span>
      </button>

      {/* Centered Logo with Enhanced Visibility */}
      <div className="absolute left-1/2 transform -translate-x-1/2 text-center">
        <h1 className="text-black text-xl md:text-3xl font-bold">CRIME</h1>
        <p className="text-black text-sm md:text-lg font-medium">Law Enforcement</p>
      </div>

      {/* Icons Section */}
      <div className="flex items-center space-x-4 md:space-x-6">
        <button className="p-2 md:p-3 bg-gray-100 rounded-full hover:bg-gray-200 transition transform hover:scale-105">
          <Search className="w-5 h-5 md:w-6 md:h-6" />
        </button>
        <button className="p-2 md:p-3 bg-gray-100 rounded-full hover:bg-gray-200 transition transform hover:scale-105">
          <Menu className="w-5 h-5 md:w-6 md:h-6" />
        </button>
      </div>
    </header>
  );
}
